import React from 'react';
import { useState, useEffect } from 'react';
import '@fontsource/roboto/400.css';
import Box from '@mui/material/Box';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import NavBar_Top from '../../NavBar_Top/NavBar_Top';
import Rodape from '../../Rodape/Rodape';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import SearchIcon from '@mui/icons-material/Search';
//import FilterltIcon from '@mui/icons-material/FilterAlt';
import '@fontsource/roboto/400.css';
//import Switch from '@mui/material/Switch';
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';
import 'leaflet/dist/leaflet.css';
import ImagemMotoboy from '../../../assets/img/motoboy_nafil.jpg';
import Menu_Navegacao from './Menu_Navegacao';
import { Grid, TextField, Button, Typography, Modal } from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br'
import { MapContainer, TileLayer, Polyline, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import CloseIcon from '@mui/icons-material/Close';
import L from 'leaflet';

const Roteiro = () => {

    delete L.Icon.Default.prototype._getIconUrl;
    L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
        iconUrl: require('leaflet/dist/images/marker-icon.png'),
        shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });

    const [erroNormalDataInicial, setErroNormalDataInicial] = useState(false);
    const [roteiroDataHoraIncial, setRoteiroDataHoraInicial] = useState(null);
    const [roteiroDataHoraFinal, setRoteiroDataHoraFinal] = useState(null);
    const [erroRoteiroDataFinal, setErroRoteiroDataFinal] = useState(false);
    const [roteiroMotoboy, setRoteiroMotoboy] = useState(null);
    const [erroRoteiroDataInicial, setErroRoteiroDataInicial] = useState(false);
    const [openModalRoteiro, setOpenModalRoteiro] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [coordinates, setCoordinates] = useState([]);

    const locale = 'pt-br';

    const handleDataHoraInicial = (event) => {
        let data = event;

        if (data && dayjs(data).isValid()) {
            const horaValida = dayjs(data).hour() !== 0 || dayjs(data).minute() !== 0;
            if (horaValida) {
                setErroNormalDataInicial(false)
                console.log('Data e Hora Final válidos:', data);
                setRoteiroDataHoraInicial(data);
            } else {
                setErroNormalDataInicial(true)
                console.log('Hora não definida corretamente:', data);
            }
        } else {
            setErroNormalDataInicial(true)
            console.log('O valor da data não é válido:', data);
        }
    };

    const closeModal = () => setIsModalOpen(false);

    const handleDataHoraFinal = (event) => {

        let data = event;

        if (data && dayjs(data).isValid()) {
            const horaValida = dayjs(data).hour() !== 0 || dayjs(data).minute() !== 0;
            if (horaValida) {
                setErroRoteiroDataFinal(false);
                setRoteiroDataHoraFinal(data);
            } else {
                setErroRoteiroDataFinal(true)
                console.log('Hora não definida corretamente:', data);
            }
        } else {
            setErroRoteiroDataFinal(true)
            console.log('O valor da data não é válido:', data);
        }
    };

    const MapaRoteiro = () => {

        //teste 1 (normal)
        const waypoints = [
            [37.7749, -122.4194],
            [36.7783, -119.4179],
            [35.3733, -119.0187],
            [34.0522, -118.2437],
            [33.7701, -118.1937],
            [32.7157, -117.1611],
        ];


        //teste 2e
        // const waypoints = [
        //     [34.0522, -118.2437],
        //     [36.7783, -119.4179],
        // 	[37.7749, -122.4194],			
        //     [33.7701, -118.1937],
        // 	[35.3733, -119.0187],			
        //     [32.7157, -117.1611], 
        // ];


        //teste 3
        // const waypoints = [
        //     [37.7749, -122.4194], 
        //     [34.0522, -118.2437],
        //     [36.7783, -119.4179], 
        //     [35.3733, -119.0187], 
        //     [34.0522, -118.2437], 
        //     [33.7701, -118.1937], 
        //     [32.7157, -117.1611], 
        //     ];


        const [routeCoordinates, setRouteCoordinates] = useState([]);

        useEffect(() => {

            const fetchRoute = async () => {

                const coordinatesString = waypoints
                    .map(point => `${point[1]},${point[0]}`)
                    .join(';');

                const url = `https://router.project-osrm.org/route/v1/driving/${coordinatesString}?overview=full&geometries=geojson`;

                try {
                    const response = await fetch(url);
                    const data = await response.json();
                    if (data.routes && data.routes.length > 0) {
                        // Extraí as coordenadas da rota
                        const coordinates = data.routes[0].geometry.coordinates.map(coord => [coord[1], coord[0]]);
                        setRouteCoordinates(coordinates);
                    }
                } catch (error) {
                    console.error('Erro ao obter a rota:', error);
                }
            };
            fetchRoute();
        }, [waypoints]);

        return (
            <>
                <MapContainer
                    center={waypoints[0]}
                    zoom={6}
                    style={{ height: '500px', width: '100%' }}
                >
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
                    />
                    {routeCoordinates.length > 0 && <Polyline positions={routeCoordinates} color="green" />}
                    {waypoints.map((point, index) => (
                        <Marker key={index} position={point} />
                    ))}
                </MapContainer>
            </>
        );
    }


    const ModalMapa = ({ open, onClose, coordinates }) => {
        return (
            <Modal
                open={open}
                onClose={onClose}
                aria-labelledby="map-modal-title"
                aria-describedby="map-modal-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '80%',
                        height: '80%',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    <MapContainer
                        center={coordinates}
                        zoom={13}
                        style={{ width: '100%', height: '100%' }}
                    >
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        />
                        <Marker position={coordinates}></Marker>
                    </MapContainer>
                    <Button startIcon={<CloseIcon />} color='success' onClick={onClose} variant="contained" size='small' >Fechar</Button>
                </Box>
            </Modal>
        );
    }

    const FilterRoteiro = () => {

        return (
            <Grid container spacing={3} >
                <Grid item xs={3}>
                    <TextField id="motoboy" onChange={(e) => setRoteiroMotoboy(e.target.value)} label="Motoboy" fullWidth type='number' variant="outlined" />
                </Grid>
                <Grid item xs={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
                        <DesktopDateTimePicker
                            label="Data e Hora Inicial"
                            value={roteiroDataHoraIncial}
                            erro={erroRoteiroDataInicial}
                            onChange={e => handleDataHoraInicial(e)}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={3}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
                        <DesktopDateTimePicker
                            label="Data e Hora Final"
                            value={roteiroDataHoraFinal}
                            erro={erroRoteiroDataFinal}
                            onChange={e => handleDataHoraFinal(e)}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={3}>
                    <Button size={'large'} onClick={() => setOpenModalRoteiro(true)} fullWidth startIcon={<SearchIcon />} color='success' variant="contained">Filtrar</Button>
                </Grid>
            </Grid>
        );
    }
    return (
        <>
            <NavBar_Top />
            <br />
            <Menu_Navegacao />
            <br />
            <br />
            <Grid container spacing={3} justifyContent={'center'}>
                <Box sx={{ width: '1200px' }}>
                    <br />
                    <br />
                    {FilterRoteiro()}
                </Box>
                <Grid item xs={12} >
                    <Box sx={{ width: '1200px', mx: 'auto' }}>
                        {
                            !openModalRoteiro
                                ?
                                <img src={ImagemMotoboy} width={'450px'} alt='Erro ao gerar a imagem' />
                                :
                                <MapaRoteiro />
                        }
                    </Box>
                </Grid>
            </Grid >
            <ModalMapa open={isModalOpen} onClose={closeModal} coordinates={coordinates} />
            <br />
            <Rodape />
            <ToastContainer />
        </>
    );
}

export default Roteiro;